import type { ImageSourcePropType } from 'react-native';

export interface IOnBoardingItem {
  id: number;
  image: ImageSourcePropType;
  title: string;
  subtitle: string;
  height?: number;
  width?: number;
  background: ImageSourcePropType;
}

export interface IOnBoardingProps {
  data: IOnBoardingItem[];
  handleFinish: () => void;
}

export interface IOnBoardingFooterProps {
  handlePrev: () => void;
  handleNext: () => void;
  handleFinish: () => void;
  totalSlides: number;
  currentSlideIndex: number;
}
